// extracted by mini-css-extract-plugin
export var root = "PlasmicHomeHeader-module--root--1DGSu";
export var link = "PlasmicHomeHeader-module--link--z0Os4";
export var slotTitle = "PlasmicHomeHeader-module--slotTitle--tp0gk";
export var authorBio = "PlasmicHomeHeader-module--authorBio--mF1Cw";
export var svg__awAbS = "PlasmicHomeHeader-module--svg__awAbS--157GM";